import React, { useEffect, useState } from "react";
import Flex from "../../../../../../../../components/structure/Flex";
import { useAuthenticatedApi } from "../../../../../../../../hooks/useApi";

interface UserStatsProps {}

const UserStats: React.FC<UserStatsProps> = () => {
  const [bookingReport, setBookingReport] = useState<any>();

  const bookingReportApi = useAuthenticatedApi("STAY_MY_BOOKING_REPORT");

  useEffect(() => {
    if (bookingReportApi) {
      bookingReportApi.get("").then((res: any) => {
        setBookingReport(res.data);
      });
    }
  }, [bookingReportApi]);

  return (
    <div className="p-4 mb-8 bg-gray-200 rounded-lg">
      <div className="grid grid-cols-2 gap-4 ">
        <Flex col className="p-4 bg-gray-100 rounded-lg">
          <div className="font-medium text-center text-md">Zostel Visited</div>
          <div className="text-sm text-center text-gray-700 sm:text-base">
            {bookingReport?.visited}
          </div>
        </Flex>
        <Flex col className="p-4 bg-gray-100 rounded-lg">
          <div className="font-medium text-center text-md">Stay Nights</div>
          <div className="text-sm text-center text-gray-700 sm:text-base">
            {bookingReport?.stay_nights}
          </div>
        </Flex>
      </div>
    </div>
  );
};

export default UserStats;
